/**
 * SearchDebounceBar — fin liseré 2 px sous une barre de recherche,
 * animé de gauche → droite pendant les 250 ms de debounce. Se démonte
 * dès que la requête part.
 *
 * Spec rev162 (Documents) + rev163 (extension Tâches / AVI). L'appelant
 * fournit un booléen `active` (typiquement `search !== debouncedSearch`)
 * et une `color` cohérente avec le module.
 *
 * Placement : à l'intérieur d'un parent en `position: relative`, juste
 * après le `<input>`.
 */
export default function SearchDebounceBar({ active, color = "#0078D4", durationMs = 250, testid }) {
  if (!active) return null;
  const keyframes = `@keyframes ledesk-search-debounce { from { transform: scaleX(0); } to { transform: scaleX(1); } }`;
  return (
    <>
      <style>{keyframes}</style>
      <div
        aria-hidden="true"
        data-testid={testid}
        style={{
          position: "absolute",
          left: 0,
          right: 0,
          bottom: -3,
          height: 2,
          background: color,
          borderRadius: 1,
          transformOrigin: "left center",
          animation: `ledesk-search-debounce ${durationMs}ms linear forwards`,
          pointerEvents: "none",
        }}
      />
    </>
  );
}
